import React, { useState, useEffect } from "react";
import AsyncSelect from "react-select/async";
import PaymentReceipt from "./PaymentReceipt";
import { customFetch } from '../apiClient';

// ✅ DYNAMIC STYLES FOR REACT SELECT (COMPACT)
const selectStyles = {
  control: (base, state) => ({
    ...base,
    minHeight: '26px',
    height: '26px',
    fontSize: '11px',
    borderRadius: '4px',
    borderColor: state.isFocused ? 'var(--theme-color, #0088cc)' : '#cbd5e0',
    boxShadow: state.isFocused ? '0 0 0 2px color-mix(in srgb, var(--theme-color, #0088cc), transparent 85%)' : 'none',
    '&:hover': { borderColor: 'var(--theme-color, #0088cc)' },
    padding: '0'
  }),
  valueContainer: (base) => ({ ...base, padding: '0 6px', height: '24px' }),
  indicatorsContainer: (base) => ({ ...base, height: '24px' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 4px' }),
  clearIndicator: (base) => ({ ...base, padding: '0 4px' }),
  input: (base) => ({ ...base, margin: '0', padding: '0', fontSize: '11px' }),
  menu: (base) => ({ ...base, zIndex: 99999, borderRadius: '4px' }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  option: (base, state) => ({
    ...base,
    fontSize: '11px',
    padding: '6px 10px',
    backgroundColor: state.isSelected 
      ? 'var(--theme-color, #0088cc)' 
      : state.isFocused 
        ? 'color-mix(in srgb, var(--theme-color, #0088cc), white 90%)' 
        : 'white',
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer',
    '&:active': { backgroundColor: 'var(--theme-color, #0088cc)', color: 'white' }
  }),
  placeholder: (base) => ({ ...base, color: '#a0aec0', fontSize: '11px' })
};

const ReportBillPayment = () => {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedSearch, setSelectedSearch] = useState(null); 
  const [cid, setCid] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);

  const [allPaymentData, setAllPaymentData] = useState([]);
  const [paymentList, setPaymentList] = useState([]);
  const [showReceipt, setShowReceipt] = useState(false);
  const [receiptData, setReceiptData] = useState(null);
  const [companyDetails, setCompanyDetails] = useState(null);
  
  const [editPayId, setEditPayId] = useState(null);
  const [editForm, setEditForm] = useState({});
  const token = sessionStorage.getItem("token");

 useEffect(() => {
  const hospitalId = sessionStorage.getItem("hospitalId");
  if (hospitalId) {
    customFetch(`/Company/${hospitalId}`)
      .then((res) => res.json()).then(setCompanyDetails).catch(console.error);
  }
}, []);

  // ✅ LOAD SEARCH OPTIONS
  const loadSearchOptions = async (inputValue) => {
    if (!inputValue) return [];
  try {
    const res = await customFetch(`/BillingPayment/search-advanced?customerName=${encodeURIComponent(inputValue)}`);
      if (!res.ok) return [];
      const data = await res.json();
      const uniqueCustomers = new Map();
      data.forEach(item => {
          if(item.customer?.custName) uniqueCustomers.set(item.customer.custName, item.customer);
      });
      return Array.from(uniqueCustomers.values()).map(cust => ({
        label: `${cust.custName} (${cust.mobileNo})`,
        value: cust.custName,
        mobile: cust.mobileNo
      }));
    } catch { return []; }
  };

  const handleSearchSelect = (selected) => {
    setSelectedSearch(selected);
    handleSearch(1, rowsPerPage || 10, selected);
  };

  const handleSearch = async (page = 1, rows = rowsPerPage || 10, searchOpt = selectedSearch) => {
    try {
      const params = new URLSearchParams();
      if (fromDate) params.append("fromDate", new Date(fromDate).toISOString());
      if (toDate) params.append("toDate", new Date(toDate).toISOString());

      if (searchOpt) {
         if (/^\d+$/.test(searchOpt.value)) params.append("mobileNo", searchOpt.value);
         else params.append("customerName", searchOpt.value);
      }
      if (cid) params.append("cid", cid);

    const res = await customFetch(`/BillingPayment/search-advanced?${params.toString()}`);

      if (!res.ok) {
        setAllPaymentData([]); setPaymentList([]); setTotalRecords(0); return;
      }

      const allData = await res.json();
      setAllPaymentData(allData); setTotalRecords(allData.length);
      applyPagination(allData, page, rows);
    } catch (e) {
      setAllPaymentData([]); setPaymentList([]); setTotalRecords(0);
    }
  };

  const applyPagination = (data, page, rows) => {
    const startIndex = (page - 1) * rows;
    const endIndex = startIndex + rows;
    setPaymentList(data.slice(startIndex, endIndex));
    setCurrentPage(page);
  };

  const handlePageChange = (page) => {
    const effectiveRows = rowsPerPage || 10;
    applyPagination(allPaymentData, page, effectiveRows);
  };
const handleEditClick = (payment, customer) => {
    setEditPayId(payment.payId);
    
    // ✅ Date Conversion Logic for DateTime Picker
    let formattedDate = "";
    if (payment.payDate) {
        const d = new Date(payment.payDate);
        // Timezone adjustment taaki local time sahi dikhe
        d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
        formattedDate = d.toISOString().slice(0, 16); // YYYY-MM-DDTHH:mm
    }

    setEditForm({
        remarks: payment.remarks || "",
        payDate: formattedDate, // ✅ Updated
        cash: payment.cash || 0,
        upi: payment.upi || 0,
        cid: customer?.cid || 0,
        payMode: payment.payMode || "",
        ipdId: payment.ipdId || payment.IpdId || null // ✅ FIXED: IpdId ko editForm me zaroor rakhna hai!
    });

    // Focus Date Input
    setTimeout(() => {
        document.getElementById(`edit-date-${payment.payId}`)?.focus();
    }, 100);
  };
  const computedReceived = () => (Number(editForm.cash) || 0) + (Number(editForm.upi) || 0);

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };

  // ✅ KEYBOARD NAVIGATION FUNCTION
  const handleKeyDown = (e, field, payId) => {
    if (e.key === 'Enter') {
        e.preventDefault();
        
        if (field === 'date') {
            document.getElementById(`edit-remarks-${payId}`)?.focus();
        } else if (field === 'remarks') {
            document.getElementById(`edit-cash-${payId}`)?.focus();
        } else if (field === 'cash') {
            document.getElementById(`edit-upi-${payId}`)?.focus();
        } else if (field === 'upi') {
            handleSaveEdit(payId); // Last field triggers save
        }
    }
  };

  const handleSaveEdit = async (payId) => {
    try {
      const received = (Number(editForm.cash) || 0) + (Number(editForm.upi) || 0);
      const payload = { ...editForm, payId, received, cid: editForm.cid ?? 0 };

    const res = await customFetch(`/BillingPayment/${payId}`, {
      method: "PUT", 
      body: JSON.stringify(payload)
    });

      if (!res.ok) throw new Error("Failed to update payment");

      // ✅ FIX: Ensure values are converted to Numbers so formatNumber doesn't return blank
      const updatedData = allPaymentData.map((p) =>
        p.payment.payId === payId ? { 
            ...p, 
            payment: { 
                ...p.payment, 
                ...editForm, 
                cash: Number(editForm.cash), // Convert String to Number
                upi: Number(editForm.upi),   // Convert String to Number
                received: Number(received)   // Ensure Number
            } 
        } : p
      );
      
      setAllPaymentData(updatedData);
      applyPagination(updatedData, currentPage, rowsPerPage || 10);
      setEditPayId(null);
    } catch (e) { alert(e.message); }
  };

  const handleDeleteClick = async (payId) => {
    if (!window.confirm("Delete payment?")) return;
   try {
    const res = await customFetch(`/BillingPayment/${payId}`, {
      method: "DELETE"
    });
      if (!res.ok) throw new Error("Failed delete");
      
      const filtered = allPaymentData.filter(p => p.payment.payId !== payId);
      setAllPaymentData(filtered); setTotalRecords(filtered.length);
      applyPagination(filtered, currentPage, rowsPerPage || 10);
    } catch (e) { alert(e.message); }
  };

  const handlePreviewClick = (data) => { setReceiptData(data); setShowReceipt(true); };
  const handleCancelEdit = () => { setEditPayId(null); };
  
  // ✅ Format number checks for type number
  const formatNumber = (num) => (typeof num === "number" ? num.toFixed(2) : "");

  const effectiveRows = rowsPerPage || 10;
  const totalPages = Math.ceil(totalRecords / effectiveRows);

  const renderPagination = () => {
    if (!effectiveRows || totalRecords === 0) return null;
    const pageNumbers = [];
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) startPage = Math.max(1, endPage - maxVisible + 1);

    return (
      <div className="pagination-controls">
        <button className="btn-page" disabled={currentPage === 1} onClick={() => handlePageChange(currentPage - 1)}><i className="bi bi-chevron-left"></i></button>
        {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map(num => (
            <button key={num} className={`btn-page ${currentPage === num ? "active" : ""}`} onClick={() => handlePageChange(num)}>{num}</button>
        ))}
        <button className="btn-page" disabled={currentPage === totalPages} onClick={() => handlePageChange(currentPage + 1)}><i className="bi bi-chevron-right"></i></button>
      </div>
    );
  };

  return (
    <div className="report-payment-container">
      <div className="report-card">
        <div className="report-header">
           <div className="header-left">
             <div className="header-icon"><i className="bi bi-credit-card"></i></div>
             <div className="header-text"><h5>Bill Payment Report</h5></div>
           </div>
        </div>

        <div className="card-content">
          
          {/* Filters */}
          <div className="filters-section">
             <div className="filter-group">
                <label><i className="bi bi-calendar"></i> From Date</label>
                <input type="date" className="filter-input" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
             </div>
             <div className="filter-group">
                <label><i className="bi bi-calendar"></i> To Date</label>
                <input type="date" className="filter-input" value={toDate} onChange={(e) => setToDate(e.target.value)} />
             </div>
             <div className="filter-group flex-2">
                <label><i className="bi bi-search"></i> Search Patient</label>
                <AsyncSelect
                  cacheOptions loadOptions={loadSearchOptions} onChange={handleSearchSelect} value={selectedSearch}
                  placeholder="Search Name or Mobile..." isClearable styles={selectStyles}
                />
             </div>
             <div className="filter-group">
                <label>CID</label>
                <input type="number" className="filter-input" value={cid} onChange={(e) => setCid(e.target.value)} placeholder="CID" />
             </div>
             <div className="filter-group">
                <label><i className="bi bi-list-ol"></i> Rows</label>
                <input type="number" className="filter-input" value={rowsPerPage} onChange={(e) => {setRowsPerPage(Number(e.target.value)); setCurrentPage(1);}} />
             </div>
             <div className="filter-group align-end">
                <button className="btn-search" onClick={() => handleSearch(1, rowsPerPage)}>Search</button>
             </div>
          </div>

          <div className="records-info">
              Showing {((currentPage - 1) * effectiveRows) + 1} to {Math.min(currentPage * effectiveRows, totalRecords)} of {totalRecords} entries
          </div>

          {/* Table */}
          <div className="table-section">
            <div className="table-responsive">
              <table className="custom-table">
                <thead>
                  <tr>
                    <th>Name</th><th>Mobile</th><th>Pay ID</th><th>Date</th><th>Remarks</th>
                    <th className="text-right">Cash</th><th className="text-right">UPI</th><th className="text-right">Received</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {paymentList.length === 0 ? (
                    <tr><td colSpan="9" className="empty-state"><p>No payment records found.</p></td></tr>
                  ) : (
                    paymentList.map(({ payment, customer }) => (
                      <tr key={payment.payId}>
                        <td>{customer?.custName || "-"}</td>
                        <td>{customer?.mobileNo || "-"}</td>
                        <td>{payment.payId}</td>
                       <td>
                          {editPayId === payment.payId ? (
                              <input 
                                  id={`edit-date-${payment.payId}`}
                                  type="datetime-local"  // ✅ Change type to datetime-local
                                  name="payDate" 
                                  value={editForm.payDate} 
                                  onChange={handleEditChange} 
                                  className="table-input"
                                  onKeyDown={(e) => handleKeyDown(e, 'date', payment.payId)}
                                  style={{ minWidth: '130px' }} // Thoda width badhana padega
                              />
                          ) : (
                              // ✅ View Mode: Show Date AND Time
                              new Date(payment.payDate).toLocaleString() 
                          )}
                      </td>
                        <td>
                           {editPayId === payment.payId ? 
                             <input 
                               id={`edit-remarks-${payment.payId}`}
                               type="text" 
                               name="remarks" 
                               value={editForm.remarks} 
                               onChange={handleEditChange} 
                               className="table-input"
                               onKeyDown={(e) => handleKeyDown(e, 'remarks', payment.payId)}
                             /> : 
                             payment.remarks
                           }
                        </td>
                        <td className="text-right">
                           {editPayId === payment.payId ? 
                             <input 
                               id={`edit-cash-${payment.payId}`}
                               type="number" 
                               name="cash" 
                               value={editForm.cash} 
                               onChange={handleEditChange} 
                               className="table-input text-right"
                               onKeyDown={(e) => handleKeyDown(e, 'cash', payment.payId)}
                             /> : 
                             formatNumber(payment.cash)
                           }
                        </td>
                        <td className="text-right">
                           {editPayId === payment.payId ? 
                             <input 
                               id={`edit-upi-${payment.payId}`}
                               type="number" 
                               name="upi" 
                               value={editForm.upi} 
                               onChange={handleEditChange} 
                               className="table-input text-right"
                               onKeyDown={(e) => handleKeyDown(e, 'upi', payment.payId)}
                             /> : 
                             formatNumber(payment.upi)
                           }
                        </td>
                        <td className="text-right fw-bold text-success">
                           {editPayId === payment.payId ? 
                             <input 
                               type="number" 
                               value={computedReceived()} 
                               readOnly 
                               className="table-input readonly text-right" 
                             /> : 
                             formatNumber(payment.received)
                           }
                        </td>
                        <td className="text-center">
                           <div className="btn-group-actions">
                             {editPayId === payment.payId ? (
                               <>
                                 <button className="btn-icon btn-save" onClick={() => handleSaveEdit(payment.payId)} title="Save"><i className="bi bi-check-lg"></i></button>
                                 <button className="btn-icon btn-cancel" onClick={handleCancelEdit} title="Cancel"><i className="bi bi-x-lg"></i></button>
                               </>
                             ) : (
                               <>
                                 <button className="btn-icon btn-edit" onClick={() => handleEditClick(payment, customer)} title="Edit"><i className="bi bi-pencil-square"></i></button>
                                 <button className="btn-icon btn-delete" onClick={() => handleDeleteClick(payment.payId)} title="Delete"><i className="bi bi-trash"></i></button>
                                 <button className="btn-icon btn-preview" onClick={() => handlePreviewClick({ payment, customer })} title="Receipt"><i className="bi bi-eye"></i></button>
                               </>
                             )}
                           </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Pagination */}
          {totalPages > 1 && <div className="pagination-section">{renderPagination()}</div>}

        </div>
      </div>

      {showReceipt && receiptData && companyDetails && (
        <PaymentReceipt show={true} hospital={companyDetails} customer={receiptData.customer} payment={receiptData.payment} onClose={() => setShowReceipt(false)} onPrint={() => window.print()} />
      )}

     {/* ✅ CSS STYLES (COMPACT) */}
      <style jsx>{`
        *, *::before, *::after { box-sizing: border-box; }
        .report-payment-container { padding: 0; font-family: system-ui, sans-serif; }
        .report-card { background: white; border-radius: 6px; box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06); border: 1px solid #e0e6ed; overflow: visible; }
        
        /* HEADER */
        .report-header { background: var(--theme-color, #0088cc); padding: 6px 12px; border-bottom: 2px solid rgba(0,0,0,0.1); border-radius: 6px 6px 0 0; }
        .header-left { display: flex; align-items: center; gap: 8px; color: white; }
        .header-icon { width: 26px; height: 26px; background: rgba(255, 255, 255, 0.2); border-radius: 4px; display: flex; align-items: center; justify-content: center; font-size: 14px; }
        .header-text h5 { margin: 0; font-size: 13px; font-weight: 600; line-height: 1.2; }
        
        .card-content { padding: 10px 12px; }
        
        /* FILTERS */
        .filters-section { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px, 1fr)); gap: 8px; background: #f8f9fa; padding: 8px 10px; border-radius: 5px; border: 1px solid #e0e6ed; margin-bottom: 10px; }
        .filter-group { display: flex; flex-direction: column; }
        .filter-group.flex-2 { grid-column: span 2; }
        .filter-group label { font-size: 10px; font-weight: 600; color: #2c3e50; margin-bottom: 2px; display: flex; align-items: center; gap: 4px; }
        .filter-group label i { color: var(--theme-color, #0088cc); font-size: 11px; }
        
        .filter-input { height: 26px; min-height: 26px; padding: 2px 6px; border: 1px solid #cbd5e0; border-radius: 4px; font-size: 11px; color: #2c3e50; outline: none; transition: none; width: 100%; }
        .filter-input:focus { border-color: var(--theme-color, #0088cc); box-shadow: 0 0 0 2px color-mix(in srgb, var(--theme-color), transparent 85%); }
        
        .align-end { justify-content: flex-end; }
        .btn-search { height: 26px; padding: 0 14px; background: var(--theme-color, #0088cc); color: white; border: none; border-radius: 4px; font-size: 11px; font-weight: 600; cursor: pointer; transition: opacity 0.2s; margin-top: auto; }
        .btn-search:hover { opacity: 0.9; }
        
        .records-info { font-size: 11px; color: #64748b; margin-bottom: 8px; font-weight: 500; }
        
        /* TABLE */
        .table-section { background: white; border-radius: 4px; border: 1px solid #e0e6ed; overflow: hidden; }
        .table-responsive { overflow-x: auto; }
        .custom-table { width: 100%; border-collapse: collapse; font-size: 11px; }
        .custom-table thead { background: #f1f5f9; border-bottom: 1px solid #cbd5e0; }
        .custom-table th { color: #2c3e50; padding: 6px 8px; text-align: left; font-weight: 600; font-size: 10px; text-transform: uppercase; white-space: nowrap; border-right: 1px solid #e0e6ed; }
        .custom-table th:last-child { border-right: none; }
        .custom-table td { padding: 4px 8px; border-bottom: 1px solid #e0e6ed; border-right: 1px solid #e0e6ed; vertical-align: middle; white-space: nowrap; }
        .custom-table td:last-child { border-right: none; }
        .custom-table tr:hover { background: #f8fafc; }
        
        /* TABLE INPUTS (EDIT MODE) */
        .table-input { background: transparent; border: 1px solid transparent; height: 22px; min-height: 22px; padding: 0 4px; font-size: 11px; width: 100%; outline: none; }
        .table-input:focus { background: white; border: 1px solid var(--theme-color, #0088cc); border-radius: 3px; }
        .readonly { background: #f9f9f9; cursor: default; color: #666; }
        
        /* UTILS */
        .text-right { text-align: right !important; }
        .text-center { text-align: center !important; }
        .fw-bold { font-weight: 700; }
        .fw-medium { font-weight: 600; }
        .text-success { color: #15803d !important; }
        
        /* BUTTONS */
        .btn-icon { width: 22px; height: 22px; border-radius: 3px; border: none; display: inline-flex; align-items: center; justify-content: center; cursor: pointer; transition: background 0.2s; margin: 0 2px; font-size: 11px; }
        .btn-edit { background: #e0f2fe; color: #0284c7; }
        .btn-edit:hover { background: #0284c7; color: white; }
        .btn-delete { background: #fee2e2; color: #dc2626; }
        .btn-delete:hover { background: #dc2626; color: white; }
        .btn-preview { background: #fef08a; color: #854d0e; }
        .btn-preview:hover { background: #eab308; color: white; }
        .btn-save { background: #dcfce7; color: #15803d; }
        .btn-save:hover { background: #15803d; color: white; }
        .btn-cancel { background: #f1f5f9; color: #64748b; }
        .btn-cancel:hover { background: #64748b; color: white; }
        .btn-group-actions { display: flex; justify-content: center; gap: 4px; }
        
        .empty-state { text-align: center; padding: 20px; color: #94a3b8; font-size: 11px; }
        
        /* PAGINATION */
        .pagination-section { display: flex; justify-content: center; margin-top: 10px; padding-top: 10px; border-top: 1px solid #e0e6ed; }
        .pagination-controls { display: flex; gap: 4px; }
        .btn-page { width: 24px; height: 24px; border: 1px solid #cbd5e0; background: white; border-radius: 4px; cursor: pointer; display: flex; align-items: center; justify-content: center; font-size: 11px; transition: all 0.2s; color: #2c3e50; }
        .btn-page:hover:not(:disabled) { background: #f1f5f9; border-color: var(--theme-color, #0088cc); color: var(--theme-color, #0088cc); }
        .btn-page.active { background: var(--theme-color, #0088cc); color: white; border-color: var(--theme-color, #0088cc); }
        .btn-page:disabled { opacity: 0.5; cursor: not-allowed; background: #f8fafc; }
        
        @media (max-width: 768px) {
          .filters-section { grid-template-columns: 1fr; }
          .filter-group.flex-2 { grid-column: span 1; }
          .custom-table { min-width: 1000px; }
        }
      `}</style>
    </div>
  );
};

export default ReportBillPayment;